import getLang from 'academy-common-lib/utils/getLang';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import http from 'hub-http/clients/apiClient';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
const GET_LESSON = registerQuery({
  fieldName: 'lesson',
  args: ['lessonId', 'language'],
  fetcher({
    lessonId,
    language
  }) {
    return http.get(`/academy-catalog/v1/lessons/${lessonId}/${language}`);
  }
});
const GET_PUBLIC_LESSON = registerQuery({
  fieldName: 'lessonPublic',
  args: ['lessonId', 'language'],
  fetcher({
    lessonId,
    language
  }) {
    return noAuthApiClient.get(`/academy-catalog-public/v1/lessons/id/${lessonId}/language/${language}`);
  }
});
export const useFullLesson = (lessonId, language = getLang(), skip) => {
  const {
    loading: lessonLoading,
    data: lesson,
    error: lessonError
  } = useQuery(GET_LESSON, {
    variables: {
      lessonId,
      language
    },
    skip
  });
  return {
    lesson,
    lessonLoading,
    lessonError
  };
};
export const useFullLessonPublic = (lessonId, language = getLang(), skip) => {
  const {
    loading: lessonLoading,
    data: lesson,
    error: lessonError
  } = useQuery(GET_PUBLIC_LESSON, {
    variables: {
      lessonId,
      language
    },
    skip
  });
  return {
    lesson,
    lessonLoading,
    lessonError
  };
};